import router from './router'
import store from './store'




router.beforeEach(async (to, from, next) => {
    // start progress bar
    // NProgress.start()
    let menuArr = store.state.menuCodes
    if (menuArr.length == 0) {
        const menuCodes = await store.dispatch('getIndexContent')
        // generate accessible routes map based on roles
        // if()
        const accessRoutes = await store.dispatch('generateRoutes', {
            menuCodes
        })
        router.addRoutes(accessRoutes)
    }

    // dynamically add accessible routes
    // router.addRoutes(accessRoutes)
    next()

})

router.afterEach(() => {
    // finish progress bar
    // NProgress.done()
})